<template>
    <el-dialog custom-class="dialog-add-coupon" :visible.sync="visible"
               append-to-body>
        <div class="inner">
            <app-title>添加优惠券</app-title>
            <el-form label-position="top" label-width="80px" :model="form" :rules="rules" ref="form">
                <el-form-item label="券码" prop="code" :error="codeErrorMsg" style="margin: 30px auto 50px">
                    <el-input v-model="form.code" type="text" clearable></el-input>
                </el-form-item>
                <app-button @click.native="add" size="md" color="golden-solid" style="margin-right: 20px">添加
                </app-button>
                <app-button @click.native="visible=false" size="md" color="gray-solid">取消</app-button>
            </el-form>
        </div>
    </el-dialog>
</template>


<script>
    export default {
        data() {
            return {
                visible: false,
                codeErrorMsg: '',
                form: {
                    code: '',
                },
                rules: {
                    code: [
                        {required: true, message: '请输入券码', trigger: 'blur'},
                    ]
                }
            }
        },
        methods: {
            add() {
                this.$store.dispatch('coupon/add', {code: this.form.code}).then(() => {
                    this.visible = false;
                    this.$store.dispatch('coupon/getCouponList');

                    this.$emit('reloadData', true);
                }).catch((err) => {
                    this.codeErrorMsg = err.info;
                })
            }
        }
    }
</script>


<style lang="scss">
    .dialog-add-coupon {

    .el-dialog__header {
        padding: 0;
    }

    }
</style>
<style lang="scss" type="text/scss">
    @import "../../style/common/form";
</style>